import { Container, SxProps, Theme } from '@mui/material';
import { JSX, ReactNode } from 'react';
import clsx from 'clsx';

interface ContentProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
  className?: string;
}

const Content = ({ children, sx, className }: ContentProps): JSX.Element => (
  <Container disableGutters maxWidth={false} sx={sx} className={clsx('px-7', className)}>
    {children}
  </Container>
);

export default Content;
